/* ZOALIN_SIZE_GUIDE_MODAL_V1 */
(() => {
  const FULL_SIZES = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  const LOUNGE_SIZES = ['M', 'L', 'XL', '2XL', '3XL', '4XL'];

  const standardSet = {
    label: 'Two-Piece Tunic & Pants Set',
    sizes: FULL_SIZES,
    sections: [
      { title: 'Top / Tunic', rows: [
        ['Shoulder', [39, 40, 41, 43, 44, 45, 46, 48]],
        ['Bust', [99, 104, 109, 114, 119, 124, 129, 134]],
        ['Waist', [105, 110, 115, 120, 125, 130, 135, 140]],
        ['Sleeve width', [36, 38, 39, 41, 42, 44, 45, 47]],
        ['Sleeve length', [57, 58, 59, 59, 60, 60, 61, 62]],
        ['Top length', [103, 104, 106, 107, 109, 110, 112, 113]],
      ]},
      { title: 'Pants', rows: [
        ['Elastic waist', ['64-79', '68-83', '72-87', '76-91', '80-95', '84-99', '88-103', '92-107']],
        ['Front rise', [29, 30, 30, 31, 31, 32, 33, 33]],
        ['Thigh', [67, 69, 72, 74, 77, 79, 82, 84]],
        ['Hip', [98, 103, 108, 113, 118, 123, 128, 133]],
        ['Pants length', [100, 101, 102, 103, 104, 105, 106, 107]],
      ]},
    ],
  };

  const loungeSet = {
    label: 'Relaxed Shirt & Pants Set',
    sizes: LOUNGE_SIZES,
    sections: [
      { title: 'Top / Shirt', rows: [
        ['Shoulder', [43, 44, 45, 46, 48, 49]],
        ['Bust', [108, 113, 118, 123, 128, 133]],
        ['Sleeve length', [56, 57, 58, 59, 60, 61]],
        ['Top length', [73, 74, 75, 76, 77, 78]],
      ]},
      { title: 'Pants', rows: [
        ['Elastic waist', ['68-86', '72-90', '76-94', '80-98', '84-102', '88-106']],
        ['Hip', [104, 109, 114, 119, 124, 129]],
        ['Thigh', [66, 69, 72, 75, 78, 81]],
        ['Pants length', [99, 100, 101, 102, 103, 104]],
      ]},
    ],
  };

  const dress = {
    label: 'Maxi Dress / Abaya',
    sizes: FULL_SIZES,
    sections: [{ title: 'Dress', rows: [
      ['Shoulder', [38, 39, 40, 41, 42, 43, 44, 45]],
      ['Bust', [96, 101, 106, 111, 116, 121, 126, 131]],
      ['Waist', [104, 109, 114, 119, 124, 129, 134, 139]],
      ['Sleeve width', [35, 36, 38, 39, 41, 42, 44, 45]],
      ['Sleeve length', [57, 58, 59, 60, 61, 62, 63, 64]],
      ['Dress length', [138, 139, 140, 141, 142, 143, 144, 145]],
      ['Hem sweep', [148, 153, 158, 163, 168, 173, 178, 183]],
    ]}],
  };

  const gatheredAbaya = {
    label: 'Gathered Abaya Maxi Dress',
    sizes: FULL_SIZES,
    sections: [{ title: 'Abaya', rows: [
      ['Shoulder', [38, 39, 40, 41, 42, 43, 44, 45]],
      ['Bust', [96, 101, 106, 111, 116, 121, 126, 131]],
      ['Waist', [104, 109, 114, 119, 124, 129, 134, 139]],
      ['Sleeve width', [35, 36, 38, 39, 41, 42, 44, 45]],
      ['Sleeve length', [57, 58, 59, 60, 61, 62, 63, 64]],
      ['Dress length', [139, 140, 141, 142, 143, 144, 145, 146]],
      ['Hem sweep', [162, 168, 174, 180, 186, 192, 198, 204]],
    ]}],
  };

  const openAbaya = {
    label: 'Open Abaya & Inner Dress',
    sizes: FULL_SIZES,
    sections: [{ title: 'Open Abaya', rows: [
      ['Shoulder', [39, 40, 41, 42, 43, 44, 45, 46]],
      ['Bust', [100, 105, 110, 115, 120, 125, 130, 135]],
      ['Sleeve length', [58, 59, 60, 61, 62, 63, 64, 65]],
      ['Outer length', [140, 141, 142, 143, 144, 145, 146, 147]],
      ['Inner length', [136, 137, 138, 139, 140, 141, 142, 143]],
      ['Hem sweep', [150, 156, 162, 168, 174, 180, 186, 192]],
    ]}],
  };

  const GUIDES = {
    'everyday-modest-tunic-set': standardSet,
    'soft-layered-modest-set': standardSet,
    'printed-flow-maxi-dress': standardSet,
    'graceful-button-maxi-dress': dress,
    'abstract-print-maxi-dress': dress,
    'soft-pleated-abaya-dress': gatheredAbaya,
    'relaxed-modest-lounge-set': loungeSet,
    'elegant-open-abaya': openAbaya,
    'tailored-modest-two-piece-set': standardSet,
    'everyday-tunic-and-pants-set': standardSet,
  };

  let root = null;
  let dialog = null;
  let guide = null;
  let unit = 'cm';
  let selectedSize = '';
  let returnFocus = null;

  const normalizeSize = (value) => String(value || '').trim().toUpperCase().replace(/\s+/g, '');
  const formatInches = (number) => {
    const value = Math.round((Number(number) / 2.54) * 10) / 10;
    return Number.isInteger(value) ? String(value) : value.toFixed(1);
  };
  const convertValue = (value) => {
    const parts = String(value).split(/\s*[-–]\s*/);
    if (parts.length === 2 && parts.every((part) => /^\d+(\.\d+)?$/.test(part))) {
      return parts.map(formatInches).join('–');
    }
    return /^\d+(\.\d+)?$/.test(String(value)) ? formatInches(value) : String(value);
  };
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };

  const renderTables = () => {
    if (!root || !guide) return;
    const container = root.querySelector('[data-zoalin-size-tables]');
    container.replaceChildren();
    guide.sections.forEach((section) => {
      const wrapper = element('section', 'zoalin-size-guide__table-section');
      const heading = element('div', 'zoalin-size-guide__table-title');
      heading.append(element('h3', '', section.title), element('span', '', unit === 'cm' ? 'All measurements in cm' : 'All measurements in inches'));
      const scroll = element('div', 'zoalin-size-guide__scroll');
      scroll.tabIndex = 0;
      scroll.setAttribute('aria-label', section.title + ' size chart. Scroll horizontally to see all sizes.');
      const table = document.createElement('table');
      const thead = document.createElement('thead');
      const headRow = document.createElement('tr');
      headRow.append(element('th', '', 'Measurement'));
      guide.sizes.forEach((size) => {
        const th = element('th', '', size);
        th.dataset.size = normalizeSize(size);
        th.scope = 'col';
        headRow.append(th);
      });
      thead.append(headRow);
      const tbody = document.createElement('tbody');
      section.rows.forEach(([label, values]) => {
        const row = document.createElement('tr');
        const labelCell = element('td', '', label);
        row.append(labelCell);
        values.forEach((value, index) => {
          const cell = element('td', '', unit === 'cm' ? String(value) : convertValue(value));
          cell.dataset.size = normalizeSize(guide.sizes[index]);
          cell.dataset.cm = String(value);
          row.append(cell);
        });
        tbody.append(row);
      });
      table.append(thead, tbody);
      scroll.append(table);
      wrapper.append(heading, scroll);
      container.append(wrapper);
    });
    highlightSelectedSize();
  };

  const readSelectedSize = () => {
    const handle = root?.dataset.productHandle || '';
    const picker = document.querySelector('variant-picker[data-product-handle="' + CSS.escape(handle) + '"]') || document.querySelector('variant-picker');
    if (picker) {
      const checked = Array.from(picker.querySelectorAll('input[data-option-name]:checked')).find((input) => /size/i.test(input.dataset.optionName || ''));
      if (checked?.value) return checked.value;
      const select = Array.from(picker.querySelectorAll('select')).find((node) => {
        const option = node.selectedOptions?.[0];
        return /size/i.test(option?.dataset.optionName || node.name || '');
      });
      if (select?.value) return select.value;
    }
    return root?.dataset.initialSize || '';
  };

  const highlightSelectedSize = () => {
    if (!root || !guide) return;
    selectedSize = readSelectedSize() || selectedSize;
    const normalized = normalizeSize(selectedSize);
    root.querySelectorAll('[data-size]').forEach((cell) => cell.classList.toggle('is-current', cell.dataset.size === normalized));
    const note = root.querySelector('[data-zoalin-size-selected]');
    if (normalized && guide.sizes.some((size) => normalizeSize(size) === normalized)) {
      note.textContent = 'Currently selected: ' + selectedSize;
      note.hidden = false;
    } else {
      note.hidden = true;
    }
  };

  const setUnit = (nextUnit) => {
    unit = nextUnit === 'in' ? 'in' : 'cm';
    root.querySelectorAll('[data-zoalin-size-unit]').forEach((button) => {
      const active = button.dataset.zoalinSizeUnit === unit;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    renderTables();
  };

  const open = (trigger) => {
    if (!root || !guide) return;
    returnFocus = trigger || document.activeElement;
    highlightSelectedSize();
    root.hidden = false;
    document.body.classList.add('zoalin-size-guide-open');
    dialog.focus();
  };
  const close = () => {
    if (!root || root.hidden) return;
    root.hidden = true;
    document.body.classList.remove('zoalin-size-guide-open');
    if (returnFocus?.focus) returnFocus.focus();
  };

  const initialize = () => {
    root = document.querySelector('[data-zoalin-size-guide]');
    if (!root) return;
    dialog = root.querySelector('.zoalin-size-guide__dialog');
    guide = GUIDES[root.dataset.productHandle] || standardSet;
    root.querySelector('[data-zoalin-size-guide-product]').textContent = guide.label;
    selectedSize = root.dataset.initialSize || '';
    setUnit('cm');

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-zoalin-size-guide-open]');
      if (trigger) {
        event.preventDefault();
        open(trigger);
        return;
      }
      if (event.target.closest('[data-zoalin-size-guide-close]')) {
        event.preventDefault();
        close();
        return;
      }
      const unitButton = event.target.closest('[data-zoalin-size-unit]');
      if (unitButton) setUnit(unitButton.dataset.zoalinSizeUnit);
      if (event.target.closest('variant-picker')) window.setTimeout(highlightSelectedSize, 50);
    });
    document.addEventListener('change', (event) => {
      if (event.target.closest('variant-picker')) window.setTimeout(highlightSelectedSize, 0);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) close();
      if (event.key === 'Tab' && !root.hidden) {
        const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
